export default [
  {
    caption: 'Update offers',
    action: 'updateOffers',
  },
];
